var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const Media = props => {
    const { children, className, trailingVisual, icon, align = 'leading', truncate = true } = props, rest = __rest(props, ["children", "className", "trailingVisual", "icon", "align", "truncate"]);
    return (React.createElement("div", Object.assign({ className: clsx('relative group flex space-s-3', [
            align === 'leading' && 'items-start',
            align === 'center' && 'items-center',
        ], className) }, rest),
        icon && React.createElement("div", { className: "shrink-0" }, icon),
        React.createElement("div", { className: clsx('grow min-w-0', truncate && 'truncate') }, children),
        trailingVisual && React.createElement("div", { className: "shrink-0" }, trailingVisual)));
};
//# sourceMappingURL=Media.js.map